var _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 90,
    height: 60,
    rx: 1.5,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 9.75,
    width: 57,
    height: 40.5,
    rx: 1.5,
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 9.75,
    width: 18.75,
    height: 11.25,
    rx: 1.5,
    fill: "#616161"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 22.5,
    width: 18.75,
    height: 11.25,
    rx: 1.5,
    fill: "#616161"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 35.25,
    width: 18.75,
    height: 10.5,
    rx: 1.5,
    fill: "#616161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 48.75C65 47.9216 65.6716 47.25 66.5 47.25H82.25C83.0784 47.25 83.75 47.9216 83.75 48.75V50.25H65V48.75Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid02);
export default __webpack_public_path__ + "static/media/grid_02.2d8bc2a50bcbb278d69fbc6294d40aca.svg";
export { ForwardRef as ReactComponent };